// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__g_hmY","col":"styles_col__1G4kz"};